export const DASHBOARD_FLOW_SLICE_NAME = "dashboardFlow";
export const ADMIN_FLOW_SLICE_NAME = "adminFlow";
export const COMPONENT_FLOW_SLICE_NAME = "componentFlow";
export const LEAD_MANAGEMENT_FLOW_SLICE_NAME = "leadManagement";
export const AI_CHAT_FLOW_SLICE_NAME = "aiChat";
export const PRODUCT_SELECTOR_FLOW_SLICE_NAME = "productSelector";
export const FLUTTER_BROADCAST_MODAL_SLICE_NAME = "flutterBroadcastModal";
export const FEATURE_FLOW_SLICE_NAME = "featureFlow";